import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="w-full bg-cream px-5 py-14 sm:px-8 sm:py-20" data-id="element-195" data-mp="3fznu5mfudd1w">
      <div className="mx-auto max-w-2xl" data-id="element-196" data-mp="3fxun461bgqtd">
        <h2 className="text-center font-display text-2xl font-bold leading-tight text-plum sm:text-3xl" data-id="element-197" data-mp="3b0ucrixfp1wg">
          Escuchá lo que dicen las que ya lo hicieron
        </h2>
        <div className="mt-10 space-y-5" data-id="element-198" data-mp="36wmo1lqz7ly8">
          {testimonials.map((testimonial, index) => <motion.figure key={testimonial.name} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="rounded-2xl border border-plum/10 border-l-4 border-l-gold bg-cream-deep p-5 shadow-sm sm:p-6" data-id="element-199" data-mp="32290u6mgwl4n" data-mpi={index}>
              <div className="flex" aria-label="5 de 5 estrellas" data-id="element-200" data-mp="h5oqhd9wga8h">
                {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-4 w-4 fill-gold text-gold" aria-hidden="true" data-id="element-201" data-mp="m5syeewqrwn3" />)}
              </div>
              <blockquote className="mt-3 font-sans text-sm leading-relaxed text-plum sm:text-base" data-id="element-202" data-mp="79v8vfhbpqju">
                "{testimonial.quote}"
              </blockquote>
              <figcaption className="mt-4 flex items-center gap-3" data-id="element-203" data-mp="zxr0w6vy6uaa">
                <img src={testimonial.image} alt={`Foto de ${testimonial.name}`} className="h-10 w-10 rounded-full object-cover" loading="lazy" data-id="element-204" data-mp="14w2aqhm8t4si" />
                <span className="font-sans text-xs font-bold uppercase tracking-wider text-plum-soft" data-id="element-205" data-mp="v4em0oh2m1uq">
                  {testimonial.name}, {testimonial.age}
                </span>
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}